export default "__VITE_ASSET__5b36aa47__"